import React, { useCallback } from 'react';

import Form from './Form';
import { PageContent, PageHeader } from './SchoolManagementPage.styles';
import { useHistory } from 'react-router-dom';
import NavigationBar from '../../components/NavigationBar';
import useQuiz from '../../services/swr/useQuiz';
import { QuizForm } from '../../models/Quiz';
import useToast from '../../hooks/useToast';

const CreateQuizPage = () => {
  const { push } = useHistory();
  const { addQuiz } = useQuiz();
  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: QuizForm) => {
      try {
        await addQuiz(data);
        addToast({
          type: 'success',
          title: 'Questionário criado com sucesso',
          description: 'O questionário foi criado com sucesso',
        });
        push('/quiz-management');
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro ao criar questionário',
          description:
            'Ocorreu um erro ao criar o questionário, tente novamente',
        });
      }
    },
    [addQuiz, addToast, push],
  );

  return (
    <>
      <NavigationBar />
      <PageContent isFooterEnabled={false}>
        <PageHeader>
          <h1 className="page-title">Novo Questionário</h1>
        </PageHeader>
        <Form onSubmit={handleSubmit} />
      </PageContent>
    </>
  );
};

export default CreateQuizPage;
